import React from 'react'
import event_popup_left_img from '../../assets/images/event_popup_left_img.png'
import event_popup_right_img from '../../assets/images/event_popup_right_img.png'
const EventPopup = ({ popupRef, onClose, isPopupClose, isPopupClosing, popupInnerRef, event }) => {
    if (!event) return null;
    return (
        <>
            <div className={`fixed w-full h-full z-[99999] left-0 top-0 bg-[#000c] transition-all duration-700 ease-in-out ${isPopupClose ? 'hidden' : ''} ${isPopupClosing ? 'close-popup' : 'open-popup'} `} ref={popupRef}>
                <div className='bg-charcoal shadow-[#000_0.1em_0.1em_0.3em] leading-[23px] cursor-pointer z-[999999] fixed overflow-auto p-2.5 lg:p-5 rounded-[10px] lg:top-2.5 top-[50px] lg:bottom-[10%] bottom-[2%] lg:inset-x-[10%] inset-x-[2%]' ref={popupInnerRef}>
                    <button onClick={onClose}>
                        <i className='fa fa-times-circle-o modal01-close  lg:text-3xl fixed lg:text-crimson lg:right-5 lg:top-5 text-[40px] text-[#ffcc00] -ml-5 lg:ml-0 left-2/4 lg:left-auto top-[5px]' ></i>
                    </button>
                    <h2 className='lg:text-3xl text-white block h-10 mb-[15px] font-bold text-xl text-center lg:text-left'><span className='text-gold'>♥</span> {event.title} <span className='text-gold'>♥</span> </h2>
                    <div className='flex justify-between'>
                        <div className='w-[35%] lg:block hidden'>
                            <img src={event.thumbnail_image_url} alt="" loading='lazy' className='w-full' />
                        </div>
                        <div className='lg:w-[65%] w-full text-center'>
                            <img src={event.poster_image_url} alt="" loading='lazy' className='w-full lg:w-[90%] mx-auto' />
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className={`fixed w-full h-full z-[99999] left-0 top-0 bg-[#000c] transition-all duration-700 ease-in-out ${isPopupClose ? 'hidden' : ''} ${isPopupClosing ? 'close-popup' : 'open-popup'} `} ref={popupRef}>
                <div className='bg-charcoal shadow-[#000_0.1em_0.1em_0.3em] leading-[23px] cursor-pointer z-[999999] fixed overflow-auto p-2.5 lg:p-5 rounded-[10px] lg:top-2.5 top-[50px] lg:bottom-[10%] bottom-[2%] lg:inset-x-[10%] inset-x-[2%]' ref={popupInnerRef}>
                    <button onClick={onClose}>
                        <i className='fa fa-times-circle-o modal01-close  lg:text-3xl fixed lg:text-crimson lg:right-5 lg:top-5 text-[40px] text-[#ffcc00] -ml-5 lg:ml-0 left-2/4 lg:left-auto top-[5px]' ></i>
                    </button>
                    <h2 className='lg:text-3xl text-white block h-10 mb-[15px] font-bold text-xl text-center lg:text-left'>
                        <span className='text-gold'>♥</span> {event.title} <span className='text-gold'>♥</span>
                    </h2>
                    <div className='flex justify-between flex-col lg:flex-row'>
                        <div className='lg:w-[35%] w-full mb-4 lg:mb-0'>
                            <img src={event.thumbnail_image_url} alt={event.title} loading='lazy' className='w-full' />
                        </div>
                        <div className='lg:w-[65%] w-full text-center'>
                            <img src={event.poster_image_url} alt={event.title} loading='lazy' className='w-full lg:w-[90%] mx-auto' />
                            <p className="text-white mt-4">{event.description}</p>
                            <p className="text-gold mt-2 text-sm">Date: {event.date}</p>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default EventPopup